/**
 * Transforms an array of notification objects to an array of announcement objects.
 */
export function transformNotificationsToAnnouncements(
  notifications: Transformed.Notification[] | undefined,
): Transformed.AnnouncementWithNotificationData[] {
  if (!notifications?.length) {
    return []
  }
  return notifications.map(({
    id,
    priority,
    content,
    code,
    title,
    cta,
    ctaLink,
    svgImage,
    bgColor,
    borderColor,
    promo,
  }) => ({
    id,
    message: content,
    code,
    priority,
    title,
    cta: cta ?? undefined,
    ctaLink: ctaLink ?? undefined,
    svgImage,
    bgColor,
    borderColor,
    promo: promo ?? undefined,
  }))
}
